import { Stack, styled } from "@mui/material";

const StyledFormLeftBox = styled(Stack)(({ theme }) => ({
  width: "250px",
  flexDirection: "column",
  gap: "4px",
}));

export default StyledFormLeftBox;
